import { useMemo, useState } from 'react';
import { releaseList } from '@/mocks/cinema';

const filters = ['全部', '今日上映', '即将上映', '动画', '科幻', '剧情'];

export default function Release() {
  const [filter, setFilter] = useState('全部');

  const list = useMemo(
    () =>
      releaseList.filter((m) => {
        if (filter === '全部') return true;
        if (filter === '今日上映') return m.badge === '今日上映';
        if (filter === '即将上映') return m.badge === '即将上映' || m.badge === '敬请期待';
        return m.genre.includes(filter);
      }),
    [filter],
  );

  return (
    <section id="release" className="bg-background-50">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-clapperboard-fill"></i>
              上映名单
            </span>
            <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-3xl">
              本周新片 · 上映名单
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              今天上映了什么、下周又有哪些大片定档？按类型快速筛选，看看哪一部你想看的人数最多。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-1 rounded-full bg-background-200 p-1">
            {filters.map((f) => (
              <button
                key={f}
                type="button"
                onClick={() => setFilter(f)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 text-xs font-medium transition-colors ${
                  filter === f
                    ? 'bg-primary-600 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {f}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((m) => (
            <article
              key={m.title}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
            >
              <div className="relative">
                <img
                  src={m.img}
                  alt={`${m.title} 电影海报`}
                  className="h-56 w-full object-cover object-top transition-transform duration-300 group-hover:scale-[1.03] md:h-64"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-end justify-between">
                  <div>
                    <p className="font-display text-xs text-accent-300">
                      {m.weekday} · {m.date}
                    </p>
                    <p className="text-sm font-bold text-background-50">{m.genre}</p>
                  </div>
                  {m.badge && (
                    <span
                      className={`whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-medium ${
                        m.badge === '今日上映'
                          ? 'bg-primary-500 text-background-50'
                          : 'bg-accent-500 text-background-50'
                      }`}
                    >
                      {m.badge}
                    </span>
                  )}
                </div>
              </div>

              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">{m.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{m.desc}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
                      {m.format}
                    </span>
                    <span>
                      <b className="font-medium text-foreground-900">{m.expect}</b> 万人想看
                    </span>
                  </div>
                  <span className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600">
                    看详情
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-8 rounded-lg border border-background-200 bg-background-100 p-8 text-center text-sm text-foreground-600">
            该分类下暂无可上映名单，试试其他类型吧。
          </p>
        )}
      </div>
    </section>
  );
}